/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/exclamation_triangle_medium'
export default icon
